import take from "lodash/take";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticleDate } from "~/components/article/article-author-block/article-date";
import type { plusArticleAuthorBlockArticle$key } from "~/queries/__generated__/plusArticleAuthorBlockArticle.graphql";

import {
  ArticleDateContainer,
  AvatarContainer,
  Container,
  StyledAuthorAvatar,
  StyledAuthorNames,
} from "./styles";

export type Props = {
  className?: string;
  firstNthAuthor?: number;
  reference: plusArticleAuthorBlockArticle$key;
};

export const PlusArticleAuthorBlock: FunctionComponent<Props> = ({
  className,
  firstNthAuthor,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment plusArticleAuthorBlockArticle on Article {
        ...articleDateContent
        ...authorNamesArticle
        authors {
          entityId
          ...authorAvatarAuthor
        }
      }
    `,
    reference_,
  );

  if (!article) return null;

  const authors = firstNthAuthor ? take(article?.authors, firstNthAuthor) : article?.authors;

  return (
    <Container className={className}>
      <AvatarContainer>
        {authors?.map(
          (author, index) =>
            author && (
              <StyledAuthorAvatar
                $zIndex={index}
                height={50}
                key={author.entityId}
                reference={author}
                width={50}
              />
            ),
        )}
      </AvatarContainer>
      <StyledAuthorNames firstNthAuthor={firstNthAuthor} reference={article} />
      <ArticleDateContainer>
        <ArticleDate reference={article} variant="plus" />
      </ArticleDateContainer>
    </Container>
  );
};

PlusArticleAuthorBlock.displayName = "PlusArticleAuthorBlock";
